module.exports = __webpack_public_path__ + "static/media/hero-banner.a83a97e4.png";